import { useState } from "react";
import { NavLink, useParams } from "react-router-dom";
import { MoreMenu } from "./MoreMenu.tsx";
import { CalendarIcon, HomeIcon, MenuIcon, PlusIcon, UsersIcon } from "./Icon.tsx";

const TRAY_ITEMS_LEFT = [
  { label: "Today", icon: HomeIcon, path: "", end: true },
  { label: "Calendar", icon: CalendarIcon, path: "calendar", end: false },
];

const TRAY_ITEMS_RIGHT = [
  { label: "Clients", icon: UsersIcon, path: "customers", end: false },
];

interface BottomTrayProps {
  onNewAppointment?: () => void;
}

export function BottomTray({ onNewAppointment }: BottomTrayProps = {}) {
  const { slug } = useParams<{ slug: string }>();
  const [moreOpen, setMoreOpen] = useState(false);

  return (
    <>
      {moreOpen && <MoreMenu onClose={() => setMoreOpen(false)} />}

      <nav className="zd-tray lg:hidden" aria-label="Quick navigation">
        {TRAY_ITEMS_LEFT.map(({ label, icon: Ic, path, end }) => {
          const to = `/${slug ?? ""}${path ? `/${path}` : ""}`;
          return (
            <NavLink
              key={path}
              to={to}
              end={end}
              className={({ isActive }) =>
                isActive ? "zd-tray-item active" : "zd-tray-item"
              }
            >
              <Ic size={20} />
              <span>{label}</span>
              <span className="zd-tray-dot" />
            </NavLink>
          );
        })}

        <div className="flex flex-col items-center justify-center flex-1 relative">
          <button
            onClick={onNewAppointment}
            className="zd-tray-fab absolute"
            style={{ bottom: "calc(50% + 0px)", transform: "translateY(50%) translateY(-26px)" }}
            aria-label="New appointment"
          >
            <PlusIcon size={20} />
          </button>
        </div>

        {TRAY_ITEMS_RIGHT.map(({ label, icon: Ic, path, end }) => {
          const to = `/${slug ?? ""}/${path}`;
          return (
            <NavLink
              key={path}
              to={to}
              end={end}
              className={({ isActive }) =>
                isActive ? "zd-tray-item active" : "zd-tray-item"
              }
            >
              <Ic size={20} />
              <span>{label}</span>
              <span className="zd-tray-dot" />
            </NavLink>
          );
        })}

        <button
          onClick={() => setMoreOpen(true)}
          className="zd-tray-item"
          style={{ background: "none", border: "none", cursor: "pointer" }}
        >
          <MenuIcon size={20} />
          <span>More</span>
          <span className="zd-tray-dot" />
        </button>
      </nav>
    </>
  );
}
